import { render, staticRenderFns } from "./change-log.vue?vue&type=template&id=253120a2"
import script from "./change-log.vue?vue&type=script&lang=ts"
export * from "./change-log.vue?vue&type=script&lang=ts"
import style0 from "./change-log.vue?vue&type=style&index=0&id=253120a2&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253120a2')) {
      api.createRecord('253120a2', component.options)
    } else {
      api.reload('253120a2', component.options)
    }
    module.hot.accept("./change-log.vue?vue&type=template&id=253120a2", function () {
      api.rerender('253120a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/change-log/change-log.vue"
export default component.exports